import React from "react";
import css from "./style.scss";
import directMailUpgradeSvg from "assets/images/directmailupgrade.svg";

const DirectMailUpgradeBanner = () => {
    return (
        <div className={css.upgradeBanner}>
            <div className={css.bannerContent}>
                <div className={css.bannerTitle}>
                    Direct Mail Upgrade
                </div>

                <div className={css.bannerDescription}>
                    Our upgraded Direct Mail platform is now live.
                    Mailings created using our previous version are
                    available for viewing but cannot be edited, canceled,
                    or modified.
                </div>
            </div>

            <div className={css.bannerImage}>
                <img
                    src={directMailUpgradeSvg}
                    alt="Direct Mail Upgrade"
                />
            </div>
        </div>
    );
};

export default DirectMailUpgradeBanner;